module.exports = __webpack_public_path__ + "img/logoWhite.18e938fd.png";